import HomeButton from "../../components/HomeButton";
import HomeBanner from "../../components/HomeBanner";
import {useTranslation} from "react-i18next";
import * as Icons from "react-icons/fa6";
import React, {useEffect, useState} from "react";
import Chart from "react-apexcharts";
import moment from "moment";
import getBaseUrl from "../../helpers/http";
import {RiLoader4Fill} from "react-icons/ri";
import {ToastContainer, toast} from 'react-toastify';
import Skeleton from "../../components/Skeleton";
import Alert from "../../components/Alert";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import {PiFilePdfBold, PiFileXlsBold} from "react-icons/pi";


const CustomFa6Icon = ({name}) => {
    const FaIcon = Icons[name];
    if (!FaIcon) return <p>Icon not found!</p>;

    return <FaIcon/>;
};

const Home = ({param}) => {
    const {t, i18n} = useTranslation();
    const [options, setOptions] = useState();
    const [activeButtonIndex, setActiveButtonIndex] = useState(1);
    const [chartFetchError, setChartFetchError] = useState(-1);
    const [bulletinFetchError, setBulletinFetchError] = useState(-1);
    const [bulletinDownloading, setBulletinDownloading] = useState(0);

    const [bulletinLoaded, setBulletinLoaded] = useState(0);

    const [chartList, setChartList] = useState();
    const [bulletin, setBulletin] = useState();
    const [chartDataAll, setChartDataAll] = useState(0);

    const handleButtonClick = (index) => {
        setActiveButtonIndex(index);
    };

    const downloadFile = async (id, type) => {

        if (bulletinDownloading === 1)
            return

        if (bulletinDownloading !== 0) {
            setBulletinDownloading(0)
            return
        }

        setBulletinDownloading(1)
        try {
            const downloadResponse = await fetch(getBaseUrl() + `survey/data?lang=${currentLang}&id=${id}&type=${type}`, {
                method: 'POST'
            });

            if (downloadResponse.status === 200) {

                if (downloadResponse.headers.get('Content-Type').includes('application/json')) {

                    const chartResult = await downloadResponse.json();

                    if (!chartResult.success) {
                        toast.error(chartResult.result)
                        setBulletinDownloading(2)
                    }
                } else {
                    const fileBlob = await downloadResponse.blob();

                    const url = window.URL.createObjectURL(fileBlob);
                    const a = document.createElement('a');
                    a.href = url;

                    a.download = `${bulletin.SURVEY_FILENAME}.${type}`;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                }
                setBulletinDownloading(0)
            } else {
                setBulletinDownloading(2)
                toast.error(t('home.bulletin.catchError'))
            }

        } catch (error) {
            console.log(error)
            setBulletinDownloading(2)
            toast.error(t('home.bulletin.catchError'))
        }
    };

    const currentLang = i18n.language;

    useEffect(() => {

        const chartOptions = {
            chart: {
                height: 500,
                redrawOnParentResize: true,
                stacked: activeButtonIndex === 4,
                zoom: {
                    enabled: true, // Enable zoom
                    type: 'x',     // Zoom only on the X-axis
                    autoScaleYaxis: true
                },
                animations: {
                    enabled: false
                },
                toolbar: {
                    show: true,
                    tools: {
                        download: true,
                        customIcons: [{
                            icon: 'All',
                            index: -7,
                            title: 'Get all chart data', 
                            class: 'mx-1 hover:text-[#333]',
                            click: () => setChartDataAll(1)
                        }, {
                            icon: '1y',
                            index: -8,
                            title: 'Get last 1 year data',
                            class: 'mx-1 hover:text-[#333]',
                            click: () => setChartDataAll(0)
                        }]
                    }
                }
            },
            title: {
                text: '',
                align: 'left',
                margin: 0,
                offsetX: 8,
                offsetY: 0,
                floating: false,
                style: {
                    fontSize: '22px',
                    fontWeight: 'bold',
                    color: '#163578',
                    fontFamily: 'PT Sans, sans-serif'
                },
            },
            series: [],
            colors: [],
            dataLabels: {
                enabled: false,
                formatter: (val) => {
                    return val + '%'
                }
            },
            stroke: {
                width: 4,
                curve: 'smooth'
            },
            grid: {
                borderColor: '#e7e7e7'
            },
            markers: {
                size: 0
            },
            plotOptions: {},
            xaxis: {
                categories: [],
                labels: {
                    style: {
                        colors: '#748AA1',
                        fontSize: '14px',
                        fontFamily: 'PT Sans, sans-serif'
                    }
                }
            },
            yaxis: {
                title: {
                    text: activeButtonIndex === 4 ? 'Сая ам.доллар' : undefined,
                    rotate: -90,
                    offsetX: 0,
                    offsetY: 0,
                    style: {
                        color: '#748AA1',
                        fontSize: '10px',
                        fontFamily: 'PT Sans, sans-serif'
                    },
                },
                labels: {
                    style: {
                        colors: '#748AA1',
                        fontSize: '14px',
                        fontFamily: 'PT Sans, sans-serif'
                    },
                    formatter: (val) => {
                        if (activeButtonIndex === 4)
                            // return val.toFixed(1)
                        return Number.isInteger(val) ? `${val}` : `${val.toFixed(1)}`;
                        else
                            // return val.toFixed(2) + '%'
                            // return Number.isInteger(val) ? `${val}%` : `${val.toFixed(2)}%`;
                            if (typeof val !== 'number' || isNaN(val)) {
                                return '-';
                              }
                              return Number.isInteger(val) ? `${val}%` : `${val.toFixed(2)}%`;
                    }
                }
            },
            subtitle: {
                text: '',
                align: 'right',
                margin: 0,
                offsetX: 0,
                offsetY: 485,
                floating: true,
                style: {
                    fontSize: '12px',
                    fontFamily: 'PT Sans, sans-serif',
                    color: '#748AA1'
                },
            },
            legend: {
                labels: {
                    colors: '#163578',
                    useSeriesColors: false
                },
                fontWeight: 800,
                fontSize: '16px',
                fontFamily: 'PT Sans, sans-serif'
            }
        }

        const fetchData = async () => {
            setChartFetchError(-1)
            try {
                const chartResponse = await fetch(getBaseUrl() + "chart/data?lang=" + currentLang, {
                    method: 'POST'
                });

                const chartResult = await chartResponse.json();

                if (chartResult.success) {
                    const groupedData = {};
                    const seriesColor = new Set();
                    let activeChartName = "";

                    chartResult.result.forEach(item => {
                        const {
                            CHART_ID,
                            CHART_NAME,
                            ICON,
                            SERIES_ID,
                            SERIES_NAME,
                            SERIES_COLOR,
                            SERIES_TYPE,
                            X_VALUE,
                            Y_VALUE
                        } = item;

                        if (CHART_ID === activeButtonIndex) {
                            seriesColor.add(SERIES_COLOR);
                        }

                        if (!groupedData[CHART_ID]) {
                            groupedData[CHART_ID] = {
                                CHART_ID,
                                CHART_NAME,
                                CHART_ICON: ICON,
                                SERIES: {}
                            };
                        }

                        if (!groupedData[CHART_ID].SERIES[SERIES_ID]) {
                            groupedData[CHART_ID].SERIES[SERIES_ID] = {
                                SERIES_NAME,
                                SERIES_COLOR,
                                SERIES_TYPE,
                                X_DP: [],
                                Y_DP: []
                            };
                        }

                        groupedData[CHART_ID].SERIES[SERIES_ID].X_DP.push(X_VALUE);
                        groupedData[CHART_ID].SERIES[SERIES_ID].Y_DP.push(parseFloat(Y_VALUE));
                    });

                    const chartList = Object.values(groupedData).sort((a, b) => a.CHART_ID - b.CHART_ID);
                    setChartList(chartList);
                    const activeChartData = groupedData[activeButtonIndex];

                    if (activeChartData) {
                        activeChartName = activeChartData.CHART_NAME;

                        const chartSeries = Object.values(activeChartData.SERIES).map(series => ({
                            name: series.SERIES_NAME,
                            data: chartDataAll === 0 ? series.Y_DP.slice(((activeButtonIndex === 2 || activeButtonIndex === 3) ? -12 : -8)) : series.Y_DP,
                            type: series.SERIES_TYPE
                        }));
                        const chartCategories = chartDataAll === 0 ? Object.values(activeChartData.SERIES)[0].X_DP.slice(((activeButtonIndex === 2 || activeButtonIndex === 3) ? -12 : -8)) : Object.values(activeChartData.SERIES)[0].X_DP;

                        const updatedOptions = {
                            ...chartOptions,
                            chart: {
                                ...chartOptions.chart,
                                dropShadow: {
                                    // enabled: (!(activeButtonIndex === 4 || activeButtonIndex === 2)),
                                    enabled: false,
                                    color: '#000',
                                    top: 10,
                                    left: 7,
                                    blur: 10,
                                    opacity: 0.1
                                }
                            },
                            series: chartSeries,
                            title: {...chartOptions.title, text: activeChartName},
                            colors: [...seriesColor],
                            xaxis: {
                                ...chartOptions.xaxis,
                                categories: chartCategories
                            },
                            stroke: {
                                curve: "smooth",
                                width: activeButtonIndex === 4 ? [0, 0, 0, 0, 4] : 4,
                                dashArray: activeButtonIndex === 2 ? [0, 5] : 0
                            },
                            subtitle: {
                                ...chartOptions.subtitle,
                                text: `${t("home.chart.subtitle")} - ${activeChartName} /${moment().format("YYYY.MM.DD")}/`
                            }
                        };
                        setOptions(updatedOptions);
                        setChartFetchError(0);
                    } else {
                        setChartFetchError(1);
                    }
                } else {
                    setChartFetchError(1);
                }
            } catch (error) {
                setChartFetchError(2);
                console.log('error 1', error);
            }

        };

        fetchData().then(async () => {

            try {

                const bulletinListResponse = await fetch(getBaseUrl() + "survey/sublist?surveyid=1&lang=" + currentLang, {
                    method: 'POST'
                });

                const bulletinListResult = await bulletinListResponse.json();
                if (bulletinListResult.success) {
                    setBulletin(bulletinListResult.result[0]);
                    setBulletinFetchError(0);
                } else {
                    setBulletinFetchError(1);
                }
                if (param === 'bulletin') {
                    if (bulletinLoaded === 0) {
                        const section = document.getElementById('bulletin');
                        if (section) {
                            section.scrollIntoView({behavior: 'smooth'});
                            setBulletinLoaded(1)
                        }
                    }
                } else {
                    setBulletinLoaded(0)
                }

            } catch (error) {
                console.log('error 2', error)
                setBulletinFetchError(2);
            }
        });

    }, [currentLang, activeButtonIndex, t, param, bulletinLoaded, chartDataAll])


    return (
        <div>
            <HelmetProvider>
                <Helmet>
                    <title>{t('root.meta.home.title')}</title>
                    <meta property="description" content={t('root.meta.home.description')}/>
                    <meta property="og:site_name" content={t('root.meta.home.title')}/>
                    <meta property="og:title" content={t('root.meta.home.title')}/>
                    <meta property="og:description" content={t('root.meta.home.description')}/>
                </Helmet>
            </HelmetProvider>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />


            <HomeBanner title={t("home.banner.title")}
                        text={t("home.banner.text")}
                        btnTxt={t("home.banner.btn-text")}/>
            {chartFetchError === 1 ?
                <Alert type={"error"} title={t('alert.error.title')} subtext={t('alert.error.subtitle')}/>
                : ''}
            {chartFetchError === 2 ?
                <Alert type={"warning"} title={t('alert.warning.title')} subtext={t('alert.warning.subtitle')}/> : ''}
            {chartFetchError === 0 ? <div className={"container mx-auto mt-10"}>
                <div className={"grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 px-4 sm:px-0"}>

                    {chartList?.map(e =>
                        <HomeButton
                            alt={e.CHART_NAME} key={e.CHART_ID}
                            isActive={activeButtonIndex === e.CHART_ID}
                            onClick={() => handleButtonClick(e.CHART_ID)}
                            name={e.CHART_NAME}> <CustomFa6Icon name={e.CHART_ICON}/> </HomeButton>
                    )}
                </div>
                <div
                    className={"grid grid-cols-1 gap-6 bg-white mt-8 shadow-[0px_4px_4px_0px_rgb(0,0,0,0.25)] rounded-md mx-4 sm:mx-0 p-5"}>
                    <Chart options={options} height={options.chart.height} type={options.chart.type}
                           series={options.series}
                    />
                </div>

            </div> : <Skeleton type={"ChartLoader"}/>}

            <div
                className={"relative my-20 pt-8 pb-20 bg-white"} id={"bulletin"}>
                <div className={"container mx-auto"}>
                    <div className={"flex flex-col"}>
                        <div className={"border-b-2 p-4"}>
                            <p className={"text-center text-3xl font-semibold text-[#163578]"}>{t("home.bulletin.title")}</p>
                        </div>
                        <div className={"p-4 mt-2"}>
                            <p className={"text-center text-[#163578]"}>{t("home.bulletin.subtext")}</p>
                        </div>
                        <div
                            className={"grid grid-cols-1 lg:grid-cols-2 mx-auto mt-4 w-9/12 md:w-full gаp-20 lg:gap-40 px-10 sm:px-40 md:px-52 xl:px-72 2xl:px-96"}>
                            <div className={"flex flex-col mx-auto"}>
                                <div className="relative mb-8">
                                    <img alt={t("home.bulletin.pdfSubText")}
                                         src={"/images/bulletin.webp"} className={"w-full"}/>
                                    <div
                                        className="absolute bottom-0 left-0 right-0 px-4 py-2 bg-gray-200 bg-opacity-80">
                                        {
                                            bulletinFetchError === 0 ?
                                                <p className="mt-2 text-[#163578] text-center ">{bulletin.SURVEY_NAME}</p> :
                                                <Skeleton type={"BulletinLoader"}/>
                                        }
                                    </div>
                                </div>
                                <div className={"flex flex-row gap-2 font-bold text-[#163578] text-2xl "}>
                                    <p>{t("home.bulletin.pdfTitle")}</p>
                                    <PiFilePdfBold className="w-6 my-auto"/>
                                </div>
                                {/* <p className={"text-[#748AA1] mt-0 mb-5"}>{t("home.bulletin.pdfSubText")}</p> */}
                                {(bulletinFetchError === 0 && bulletinDownloading === 0) ? <button
                                        onClick={() => downloadFile(bulletin.SURVEY_ID, 'pdf')}
                                        className="w-fit bg-[#FFB800] text-[#163578] font-bold text-sm py-2 px-4 rounded inline-flex items-center">
                                        <CustomFa6Icon name={"FaDownload"}/>
                                        <span className={"px-2"}>{t("home.bulletin.pdfButton")}</span>
                                    </button> :
                                    <button
                                        disabled
                                        className="w-fit bg-[#FFB800] text-[#163578] hover:cursor-wait font-bold text-sm py-2 px-4 rounded inline-flex items-center">
                                        <RiLoader4Fill className={"animate-spin"}></RiLoader4Fill>
                                        <span className={"px-2"}>{t("home.bulletin.buttonLoading")}</span>
                                    </button>}
                            </div>
                            <div className={"flex flex-col mx-auto mt-10 lg:mt-0"}>
                                <div className="relative mb-8">
                                    <img alt={t("home.bulletin.excelSubText")}
                                         src={"/images/bulletin.webp"} className={"w-full"}/>
                                    <div
                                        className="absolute bottom-0 left-0 right-0 px-4 py-2 bg-gray-200 bg-opacity-80">
                                        {
                                            bulletinFetchError === 0 ?
                                                <p className="mt-2 text-[#163578] text-center ">{bulletin.SURVEY_NAME}</p> :
                                                <Skeleton type={"BulletinLoader"}/>
                                        }
                                    </div>
                                </div>
                                <div className={"flex flex-row gap-2 font-bold text-[#163578] text-2xl "}>
                                    <p>{t("home.bulletin.excelTitle")}</p>
                                    <PiFileXlsBold className="w-6 my-auto"/>
                                </div>
                                {/* <p className={"text-[#748AA1] mt-0 mb-5"}>{t("home.bulletin.excelSubText")}</p> */}
                                {(bulletinFetchError === 0 && bulletinDownloading === 0) ? <button
                                        onClick={() => downloadFile(bulletin.SURVEY_ID, 'xlsx')}
                                        className="w-fit bg-[#FFB800] text-[#163578] font-bold text-sm py-2 px-4 rounded inline-flex items-center">
                                        <CustomFa6Icon name={"FaDownload"}/>
                                        <span className={"px-2"}>{t("home.bulletin.excelButton")}</span>
                                    </button> :
                                    <button
                                        disabled
                                        className="w-fit bg-[#FFB800] text-[#163578] hover:cursor-wait font-bold text-sm py-2 px-4 rounded inline-flex items-center">
                                        <RiLoader4Fill className={"animate-spin"}></RiLoader4Fill>
                                        <span className={"px-2"}>{t("home.bulletin.buttonLoading")}</span>
                                    </button>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home;